import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { getStateFromPreviousSession } from './root-state';
import * as AppStoreActions from './app-store/actions';
import { AppStoreModule } from './app-store';
import { SubsidiariesStoreModule } from './subsidiaries-store';
import { NewAccountStoreModule } from './new-account-store';
import { ContactFormStoreModule } from './contact-form-store';
import { SubsidiaryDetailStoreModule } from './subsidiary-detail-store';
import { FederationsStoreModule } from './federations-store/federations-store.module';
import { FederationDetailStoreModule } from './federation-detail-store/federation-detail-store.module';
import { UserPrefsStoreModule } from './user-prefs-store/user-prefs-store.module';


export function logout(reducer) {
	return (state, action) => {
		return reducer(action.type === AppStoreActions.Logout.type ? getStateFromPreviousSession() : state, action);
	};
}

// The metareducers option allow to reset the whole internal state on logout
// see https://ngrx.io/guide/store/metareducers
// export const MetareducedStoreModule = StoreModule.forRoot({}, { metaReducers: [logout, throwOnUndefined] });
export const MetareducedStoreModule = StoreModule.forRoot({}, {
	metaReducers: [logout],
	runtimeChecks: {
		// because we are savages
		strictStateImmutability: false,
		strictActionImmutability: false,
		strictStateSerializability: false,
		strictActionSerializability: false,
	},
});

@NgModule({
	declarations: [],
	imports: [
		AppStoreModule,
		CommonModule,
		ContactFormStoreModule,
		FederationDetailStoreModule,
		FederationsStoreModule,
		MetareducedStoreModule,
		NewAccountStoreModule,
		SubsidiariesStoreModule,
		SubsidiaryDetailStoreModule,
		UserPrefsStoreModule,
		EffectsModule.forRoot([])
	]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class RootStoreModule { }
